import { UserInterface, UserRole } from '@app/models/user';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';
import { ListResponse } from '@app/models';

export const update = async (data: Partial<UserInterface>) => {
  return apiInstance.post(`${ApiRoutes.User}/update-user`, data);
};

export const getProfile = async () => {
  return apiInstance.get(`${ApiRoutes.User}/user-profile`);
};

export const getBusinesses = async () => {
  return apiInstance.get(`${ApiRoutes.User}/businesses`);
};

export const getUserWithBusinesses = async () => {
  return apiInstance.get(`${ApiRoutes.User}/me`);
};

export const postUserPhoto = async (data: File) => {
  var formData = new FormData();
  formData.append('file', data);

  return apiInstance.post(`${ApiRoutes.User}/upload-photo`, formData);
};

export const updateUserPhoto = async (data: FormData) => {
  return apiInstance.post(`${ApiRoutes.User}/update-photo`, data);
};

export const getUserPhoto = async () => {
  return apiInstance.get(`${ApiRoutes.User}/photo`);
};

export const getSubscriptions = async () => {
  return apiInstance.get(`${ApiRoutes.User}/subscriptions`);
};

export const getCards = async () => {
  return apiInstance.get(`${ApiRoutes.User}/cards`);
};

export const updatePaymentMethod = async (data: {
  paymentMethodId: string;
  isDefault?: boolean;
  exp_month?: number;
  exp_year?: number;
  name?: string;
}) => {
  return apiInstance.put(`${ApiRoutes.User}/payment-methods/update`, data);
};

export const deletePaymentMethod = async (paymentMethodId: string) => {
  return apiInstance.delete(`${ApiRoutes.User}/payment-methods/detach`, {
    data: { paymentMethodId },
  });
};

export const updateEmail = async (data: { email: string }) => {
  return apiInstance.put(`${ApiRoutes.User}/update-email`, data);
};

export const checkPhone = async (data: { phoneNumber: string }) => {
  return apiInstance.post(`${ApiRoutes.User}/check-phone`, data);
};

export const validatePhone = async (data: { phone: string; code: string }) => {
  return apiInstance.post(`${ApiRoutes.User}/validate-phone`, data);
};

// Admin functions
export const getUsersAdmin = async (
  page: number = 1,
  perPage: number = 10,
  search?: string
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    perPage: perPage.toString(),
  });

  if (search) {
    params.append('search', search);
  }

  const res = await apiInstance.get<ListResponse<UserInterface>>(
    `${ApiRoutes.User}/?${params.toString()}`
  );

  return res.data;
};

export const updateUserAdmin = async (
  userId: string,
  data: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    resetPassword?: boolean;
    role?: UserRole;
    password?: string;
  }
) => {
  return apiInstance.put(`${ApiRoutes.User}/${userId}`, data);
};

export const deleteUserAdmin = async (userId: string) => {
  return apiInstance.delete(`${ApiRoutes.User}/${userId}`);
};
